module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AGA CME","short_name":"AGACME","start_url":"/","background_color":"#f7f0eb","theme_color":"#1A2C46","display":"minimal-ui","icon":"src/images/big-favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"477738f69f920e501869e63f8c8be365"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
